import React, { useState, useEffect } from "react";
import Modal from "../../common/Modal";
import Button from "../../common/FormFields/Button";
import CustomSelect from "../../common/FormFields/Select";
import * as dateFns from "date-fns";
import { useTranslation } from "react-i18next";

const CancelBooking = (props) => {
  const {
    bloodbankId,
    bloodbankName,
    selectedTimeslot,
    donorDetailsData,
    toggleDonorSettingsModal,
    donorSettingsModalIsOpen,
    toggleBookingCancelModal,
    bookingCancelModalIsOpen,
    cancelAppointmentBooking,
    isFromDonorDetails = false,
    currentAppointment,
  } = props;
  const { t } = useTranslation();

  const [currentAppointments, setCurrentAppointments] = useState([]);
  const [chosenAppointment, setChosenAppointment] = useState(
    currentAppointments[0],
  );

  useEffect(() => {
    setCurrentAppointments(
      selectedTimeslot?.appointments?.filter((item) => item.status === "confirmed")
        .map((item) => {
          return {
            label: `${dateFns.format(new Date(item.startDate), "HH:mm")} - ${dateFns.format(new Date(item.endDate), "HH:mm")}`,
            value: item,
          };
        }) || [],
    );
  }, [selectedTimeslot]);

  useEffect(() => {
    const initial = currentAppointments.find(
      a => Number(a.value.startDate) === currentAppointment?.startDate
    );

    let nextValue = initial;

    if (bookingCancelModalIsOpen) {
      if (currentAppointment?.status === "pending") {
        nextValue = undefined;
      } else if (currentAppointments.length === 1) {
        nextValue = currentAppointments[0];
      }
    }

    setChosenAppointment(nextValue);
  }, [
    bookingCancelModalIsOpen,
    currentAppointment?.startDate,
    currentAppointment?.status,
    currentAppointments
  ]);

  useEffect(() => {
    if (!bookingCancelModalIsOpen) {
      setChosenAppointment(null);
    }
  }, [bookingCancelModalIsOpen]);

  const handleModalClose = () => {
    toggleBookingCancelModal();
  };

  const cancelAppointment = () => {
    if (isFromDonorDetails) {
      cancelAppointmentBooking(
        bloodbankId,
        donorDetailsData.currentUser?.nextAppointment?.reservationId,
        donorDetailsData.currentUser?.id,
        donorDetailsData.currentUser?.nextAppointment?.startDate,
        bloodbankName,
      );
    }
    if (!isFromDonorDetails) {
      cancelAppointmentBooking(
        bloodbankId,
        chosenAppointment.value?.reservation?.reservationId,
        chosenAppointment.value?.reservation?.userId,
        chosenAppointment.value?.reservation?.startDate,
        bloodbankName,
      );
    }
  };

  const handleSubmit = () => {
    cancelAppointment();

    if (donorSettingsModalIsOpen) {
      toggleDonorSettingsModal();
    }
    toggleBookingCancelModal();
  };

  return (
    <>
      <Modal
        isModalOpen={bookingCancelModalIsOpen}
        handleModalClose={handleModalClose}
        {...props}
      >
        <div className="modal-header">
          <h2 className="modal-title">
            {t("configuration.settings.cancelBookingModal.header")}
          </h2>
          <button className="modal-close" onClick={handleModalClose}>
            <span className="icon-close" />
          </button>
        </div>
        <div className="modal-body modal-content">
          <div className="form-group modal-msg">
            {t("configuration.settings.cancelBookingModal.body")}
          </div>
          {!isFromDonorDetails && (
            <div className="form-group">
              <CustomSelect
                label={t(
                  "configuration.settings.cancelBookingModal.selectAppointmentTime",
                )}
                data={currentAppointments}
                value={chosenAppointment}
                onChange={setChosenAppointment}
                isSearchable={true}
              />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <div className="inputs-group">
            <div className="inputs-group-item">
              <Button
                type="button"
                text={t("common.cancel")}
                onClick={handleModalClose}
              />
            </div>
            <div className="inputs-group-item">
              <Button
                btnClassName="btn-primary"
                type="button"
                text={t("common.confirm")}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CancelBooking;
